import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import {
  DEPRECATED_backwardsCompatibleValues,
  StrictLocalizeFunction,
  useStrictLocalization,
} from "@faire/web/common/localization/localize";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import { Testimonials } from "@faire/retailer/app/visitor/[locale]/(pagesWithModal)/(pagesWithTopOfPageContent)/brand/[brandToken]/(rsc)/rsc/_sections/Testimonials/Testimonials";
import { ITestimonial } from "@faire/retailer/components/TestimonialCarousel/TestimonialCarousel";
import { getSessionCountry } from "@faire/retailer/serialized-data/getSessionCountry";

const testimonials = (
  isUSA: boolean,
  isMobile: boolean,
  strictLocalize: StrictLocalizeFunction
): ITestimonial[] => [
  {
    avatarImageUrl:
      "https://cdn.faire.com/fastly/72f810f95c17f7e377a96d5fa37775a7552c47cfd0cf40074a639b4d80803e05.png",
    content: (
      <StrictLocalMsg
        // eslint-disable-next-line @faire/no-mid-sentence-linebreaks
        defaultMessage="“If you aren’t using Faire, you’re missing a great{lineBreak}opportunity. Start today and deal with a very professional{lineBreak}company helping all shopkeepers buy quality products{lineBreak}from independent makers and artisans.”"
        values={DEPRECATED_backwardsCompatibleValues({
          lineBreak: isMobile ? " " : <br />,
        })}
      />
    ),
    reviewerInfo: isUSA
      ? strictLocalize({
          defaultMessage:
            "Cindy Davenport, Cinport Floral Studio & Gift Designs by Cinport",
        })
      : strictLocalize({
          defaultMessage:
            "Cindy Davenport, owner of Floral Studio & Gift Designs by Cinport in Florida, USA",
        }),
  },
  {
    avatarImageUrl:
      "https://cdn.faire.com/fastly/9cd7f99ab4862a8332e44f3876063e11cdf0a37efa2f634b3bc5b7c8a0fc3ca0.png",
    content: (
      <StrictLocalMsg
        // eslint-disable-next-line @faire/no-mid-sentence-linebreaks
        defaultMessage="“As our business grows, Faire has allowed us to easily try products{lineBreak}that we might not have taken the chance on before. The fact that{lineBreak}they’ve tailored the selections to fit our brand has simplified{lineBreak}our buying processes significantly.”"
        values={DEPRECATED_backwardsCompatibleValues({
          lineBreak: isMobile ? " " : <br />,
        })}
      />
    ),
    mobileContent: (
      <StrictLocalMsg defaultMessage="“As our business grows, Faire has allowed us to easily try products that we might not have taken the chance on before.”" />
    ),
    reviewerInfo: isUSA
      ? strictLocalize({
          defaultMessage: "Jake France + Richard Rolfe, Boys Fort",
        })
      : strictLocalize({
          defaultMessage:
            "Jake France + Richard Rolfe, owners of Boys Fort in Portland, USA",
        }),
  },
  {
    avatarImageUrl:
      "https://cdn.faire.com/fastly/0ded13b33fd5d5c505deb0bd98ec2fb3bc283d2fb09d10ebd82995c4bd326df9.jpeg",
    content: (
      <StrictLocalMsg
        // eslint-disable-next-line @faire/no-mid-sentence-linebreaks
        defaultMessage="“I love Faire because I don’t have to go to trade shows.{lineBreak}Faire’s website is 100% more user-friendly and better{lineBreak}designed than other wholesale sites.”"
        values={DEPRECATED_backwardsCompatibleValues({
          lineBreak: isMobile ? " " : <br />,
        })}
      />
    ),
    reviewerInfo: isUSA
      ? strictLocalize({
          defaultMessage: "John Frechette, MADE",
        })
      : strictLocalize({
          defaultMessage: "John Frechette, owner of MADE in Jackson, USA",
        }),
  },
];

export const TestimonialModule = React.forwardRef<HTMLDivElement>(
  (_props, ref) => {
    const { strictLocalize } = useStrictLocalization();
    const isUSA =
      getSessionCountry() === THREE_LETTER_PRIMARY_COUNTRY_CODES.USA;
    const myTestimonialsMobile = testimonials(isUSA, true, strictLocalize);
    const myTestimonialsDesktop = testimonials(isUSA, false, strictLocalize);

    const brandCountHeader = (
      <StrictLocalMsg
        defaultMessage="TRUSTED BY HUNDREDS OF THOUSANDS OF RETAILERS"
        description={{
          text: "testimonials header",
          img: "https://cdn.faire.com/fastly/9a1d255f3d61578599239ed48f24f1b0b3476ee6b2cf1c70b14c5e365081c63d.png",
        }}
      />
    );

    return (
      // already hardcoded with `hideStoryLink` and `withRetailerCount` true
      <Testimonials
        itemsMobile={myTestimonialsMobile}
        itemsDesktop={myTestimonialsDesktop}
        brandCountHeader={brandCountHeader}
        ref={ref}
      />
    );
  }
);
